import { SkinOutlined, GiftOutlined } from "@ant-design/icons";
import logo from "../../assests/Images/joyLogo.png";

export default function SidebarMenu({ selectedCategory, onCategorySelect, hasMultiPackProducts, hasSinglePackProducts, products = [] }) {
  // Count products for each category
  const singlePackCount = products.filter(p => !p.multiple).length;
  const multiPackCount = products.filter(p => p.multiple).length;

  const menuItems = [
    {
      key: "single-pack",
      icon: <SkinOutlined />,
      label: "Single / Small Packs",
      count: singlePackCount,
    },
    {
      key: "multi-pack",
      icon: <GiftOutlined />,
      label: "Multi / Large Packs",
      count: multiPackCount,
    },
  ];

  const handleClick = (key) => {
    if (onCategorySelect) {
      onCategorySelect(key);
    }
  };

  const handleTextAppRedirect = () => {
    let phone = "+12136993073"; // default prod

    // Extract subdomain using regex
    const hostname = window.location.hostname; // e.g., "app.dev.bundleofjoy.ai"
    const match = hostname.match(/app\.(dev|qa)\.bundleofjoy\.ai/);

    if (match) {
      if (match[1] === "dev") {
        phone = "+19299306040";
      } else if (match[1] === "qa") {
        phone = "+15012546268";
      }
    }

    const message = ""; // define your message
    const encodedMessage = encodeURIComponent(message);

    // iOS vs others
    const smsLink = /iPhone|iPad|iPod/i.test(navigator.userAgent)
      ? `sms:${phone}&body=${encodedMessage}`
      : `sms:${phone}?body=${encodedMessage}`;

    window.location.href = smsLink;
  };


  return (
    <nav className="sidebar" style={{background:"white", boxShadow:"-4px 0px 7px grey"}}>
      <button
          key={"logo"}
          className={`sidebar-btn`}
        >
          <div className="sidebar-left">
            <img src={logo} width="40px"/>
          </div>

          {/* {item.count > 0 && (
            <span className="sidebar-count">{item.count}</span>
          )} */}
        </button>
      {hasMultiPackProducts && hasSinglePackProducts && menuItems.map((item) => (
        <button
          key={item.key}
          className={`sidebar-btn ${selectedCategory === item.key ? "active" : ""}`}
          onClick={() => handleClick(item.key)}
          style={{fontSize:"10px"}}
        >
          <div className="sidebar-left">
            {item.icon}
            <p className="sidebar-label">{item.label}</p>
          </div>

          {/* {item.count > 0 && (
            <span className="sidebar-count">{item.count}</span>
          )} */}
        </button>
      ))}
      <button
          key="Back to Texting Joy"
          className={hasMultiPackProducts && hasSinglePackProducts ? "sidebar-btn texting-joy-button" : "sidebar-btn texting-joy-button m-w-100"}
          onClick={() => handleTextAppRedirect()}
          style={{fontSize:"10px",backgroundColor:"#005cff",color:"white"}}
        >Back to Texting Joy</button>
    </nav>
  );
}